module.exports = __webpack_public_path__ + "static/media/bitmap-p-p-2@1x.11f020f3.png";